import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { Footer } from '../../components/Footer';
import {
  AnalyticsSection,
  CreatorToolsSection,
  HostingAndDistributionSection,
  SponsorshipsSection,
  SubNavigation,
} from './components';

export function FeaturesScreen() {
  const [activeSection, setActiveSection] = useState('creation-tools');

  return (
    <>
      <SubNavigation activeItem={activeSection} />
      <InView
        rootMargin="-40% 0px -40% 0px"
        onChange={(inView, entry) => {
          if (
            inView &&
            entry.isIntersecting &&
            activeSection !== 'creation-tools'
          ) {
            setActiveSection('creation-tools');
          }
        }}
      >
        <CreatorToolsSection />
      </InView>
      <InView
        rootMargin="-40% 0px -40% 0px"
        onChange={(inView, entry) => {
          if (inView && entry.isIntersecting && activeSection !== 'hosting') {
            setActiveSection('hosting');
          }
        }}
      >
        <HostingAndDistributionSection />
      </InView>
      <InView
        rootMargin="-40% 0px -40% 0px"
        onChange={(inView, entry) => {
          if (inView && entry.isIntersecting && activeSection !== 'analytics') {
            setActiveSection('analytics');
          }
        }}
      >
        <AnalyticsSection />
      </InView>
      <InView
        rootMargin="-40% 0px -40% 0px"
        onChange={(inView, entry) => {
          if (
            inView &&
            entry.isIntersecting &&
            activeSection !== 'sponsorships'
          ) {
            setActiveSection('sponsorships');
          }
        }}
      >
        <SponsorshipsSection />
      </InView>
      <Footer />
    </>
  );
}
